import { Grid, TextField, Typography, Box } from "@mui/material";
import {
  requiredFieldSx,
  subsectionHeadingSx,
  sectionSubheadingSx,
} from "../onboardingTheme";

const bankFields = [
  { name: "bank_name", label: "Bank Name", required: true },
  {
    name: "account_number",
    label: "Account Number",
    required: true,
    inputProps: { inputMode: "numeric", maxLength: 18 },
  },
  {
    name: "ifsc_code",
    label: "IFSC Code",
    required: true,
    inputProps: { maxLength: 11, style: { textTransform: "uppercase" } },
  },
];

const taxFields = [
  {
    name: "pan_number",
    label: "PAN Number",
    required: false,
    inputProps: { maxLength: 10, style: { textTransform: "uppercase" } },
  },
  {
    name: "pf_number",
    label: "PF Number",
    required: false,
    inputProps: { maxLength: 30 },
  },
  {
    name: "esi_number",
    label: "ESI Number",
    required: false,
    inputProps: { maxLength: 30 },
  },
];
const BankDetailsStep = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
}) => (
  <Box>
    <Typography sx={subsectionHeadingSx}>Bank Account Details</Typography>
    <Typography sx={{ ...sectionSubheadingSx, mb: 1.5 }}>
      Enter your salary account information for payroll processing.
    </Typography>

    <Grid container spacing={{ xs: 1.5, sm: 2 }} sx={{ mb: 2 }}>
      {bankFields.map(({ name, label, required, inputProps }) => (
        <Grid item xs={12} sm={6} key={name}>
          <TextField
            fullWidth
            size="small"
            required={required}
            name={name}
            label={label}
            value={values[name] || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            sx={requiredFieldSx}
            inputProps={inputProps}
            error={touched[name] && Boolean(errors[name])}
            helperText={touched[name] && errors[name]}
          />
        </Grid>
      ))}
    </Grid>
    <Typography sx={subsectionHeadingSx}>Tax & Statutory Details</Typography>
    <Typography sx={{ ...sectionSubheadingSx, mb: 1.5 }}>
      Optional identifiers used for tax and compliance records.
    </Typography>

    <Grid container spacing={{ xs: 1.5, sm: 2 }}>
      {taxFields.map(({ name, label, required, inputProps }) => (
        <Grid item xs={12} sm={6} key={name}>
          <TextField
            fullWidth
            size="small"
            required={required}
            name={name}
            label={label}
            value={values[name] || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            sx={requiredFieldSx}
            inputProps={inputProps}
            error={touched[name] && Boolean(errors[name])}
            helperText={touched[name] && errors[name]}
          />
        </Grid>
      ))}
    </Grid>  </Box>
);

export default BankDetailsStep;
